export default "__VITE_ASSET__cf02e41a__"